export const onlyDesktop = "d-none d-lg-block"
export const onlyDesktopFlex = "d-none d-lg-flex"
export const onlyMobile = "d-lg-none"
